import React from "react";
import BgImg from "../assests/backgroundImage4.avif";
import { motion } from "framer-motion";
import BannerImg1 from "../assests/banner1.avif";
import BannerImg2 from "../assests/banner2.avif";
import { useMediaQuery, useTheme } from "@mui/material";

const Banner = () => {
    const theme = useTheme();
    const isBig = useMediaQuery(theme.breakpoints.down(1250));
    const isMobile = useMediaQuery(theme.breakpoints.down(890));
    const isSmall = useMediaQuery(theme.breakpoints.down(380));

    const styles = {
        container: {
            backgroundImage: `url(${BgImg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            color: '#fff',
            textAlign: 'center',
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        content: {
            padding: '20px',
            borderRadius: '10px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        innerBox: {
            width: isSmall ? '100%' : isMobile ? '95%' : isBig ? '90%' : '80%',
            padding: isMobile ? '5px' : '20px',
            borderRadius: '15px',
            boxSizing: 'border-box',
            marginTop: 20,
        },
        blackBox: {
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: 'center'

        },
        leftBox: {
            width: isMobile ? '100%' : '45%',
            textAlign: 'left',
            padding: isMobile ? '5px' : '20px',
            boxSizing: 'border-box',
            borderRadius: '15px'
        },
        rightBox: {
            width: isMobile ? '100%' : '45%',
            padding: isMobile ? '5px' : '20px',
            boxSizing: 'border-box',
            borderRadius: '15px',
            textAlign: 'left',
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <div
                    style={styles.innerBox}
                >
                    <div style={styles?.blackBox}>
                        <div style={styles.leftBox}>

                            {
                                isMobile ?
                                    <img src={BannerImg1} style={{ width: '100%' }} ></img>
                                    :
                                    <>
                                        <h4>Terminating the Risk For You - Stress-Free Guarantee</h4>

                                        <div style={{ lineHeight: 1.5 }}>
                                            At GroMedia, our goal is clear: to be the go-to for Ecommerce Product marketing that gets real results and to change the conversation from "I've been burned before" to trust and success. We've got your back completely. You only pay us when we deliver the goods. No results, no payment.
                                        </div>
                                    </>
                            }

                        </div>

                        <div style={styles.rightBox}>
                            {
                                isMobile
                                    ?
                                    <>
                                        <h4>Terminating the Risk For You - Stress-Free Guarantee</h4>

                                        <div style={{ lineHeight: 1.5 }}>
                                            At GroMedia, our goal is clear: to be the go-to for Ecommerce Product marketing that gets real results and to change the conversation from "I've been burned before" to trust and success. We've got your back completely. You only pay us when we deliver the goods. No results, no payment.
                                        </div>
                                    </>
                                    :
                                    <img src={BannerImg1} style={{ width: '100%' }} ></img>

                            }
                        </div>
                    </div>
                </div>



                <div
                    style={styles.innerBox}
                >
                    <div style={styles?.blackBox}>
                        <div style={styles.leftBox}>
                            <img src={BannerImg2} style={{ width: '100%' }} ></img>
                        </div>

                        <div style={{ ...styles.rightBox, textAlign: 'left', lineHeight: 1.5 }}>
                            <h2>Proven & Real Scaling Strategies & Systems</h2>

                            <div >
                                We don't follow the same old 'trial and error' methods that  many other agencies do, leaving you to foot the bill. Instead,  we rely on tried-and-tested strategies honed from our own  successful eCommerce ventures to propel your growth. Our  approach revolves around tailoring a strategy specifically  for your brand and then amplifying it using concrete data.
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div >
    );
};



export default Banner;
